module.exports = __webpack_public_path__ + "static/6-backpack-woman-8d06a1e2991542d2b05ed97aba807901.jpg";